import { Type } from "class-transformer";
import { OrderShipmentMethodKind } from "../common/order-shipment-method-kind";
import { OrderAddressDTO } from "./order-address.dto";

export class OrderDeliveryDTO {
	firstName: string;
	lastName: string;
	companyName: string;
	shipmentMethod: {
		serviceName: string;
		serviceId: string;
		kind: OrderShipmentMethodKind
	} | null;
	phone: string;
	pickupPointName: string;
	grossCost: number;
	netCost: number;
	taxExternalId: string;
	@Type(() => OrderAddressDTO) address: OrderAddressDTO | null;
	dimensions: {
		weight: number;
		width: number;
		height: number;
		length: number
	} | null;
	parcelSize: string;
	sendingParcelLocker: string;
	dispatchStart: Date | null;
	dispatchEnd: Date | null;
}